import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";

interface QueryParams {
  [key: string]: string | null;
}

const useQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Parse the query params
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location]
  );

  // Get a specific query param
  const getQueryParam = (param: string): string | null =>
    queryParams.get(param);

  // Set one or more query params
  const setQueryParams = (params: QueryParams): void => {
    const newQueryParams = new URLSearchParams(queryParams);
    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined) {
        newQueryParams.delete(key);
      } else {
        newQueryParams.set(key, value);
      }
    });
    navigate(`?${newQueryParams.toString()}`, { replace: true });
  };

  // Remove a specific query param
  const removeQueryParam = (param: string): void => {
    const newQueryParams = new URLSearchParams(queryParams);
    newQueryParams.delete(param);
    navigate(`?${newQueryParams.toString()}`, { replace: true });
  };

  return {
    getQueryParam,
    setQueryParams,
    removeQueryParam,
  };
};

export default useQueryParams;
